import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import DisclaimerModal from './components/DisclaimerModal';

function App() {
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);

  if (!disclaimerAccepted) {
    return <DisclaimerModal onAgree={() => setDisclaimerAccepted(true)} />;
  }

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;